module.exports = __webpack_public_path__ + "media/images/nini_sobre-1cbf97bdaec7c0254a7874c800d161e2.png";